import request from '@/utils/request'
// import { API_PROXY_PREFIX } from '@/services/api'

// 查询计件工资单价-CC列表
export async function listBomSalaryUnitPriceCc (query) {
  return request({
    url: '/bom/bomSalaryUnitPriceCc/list',
    method: 'get',
    params: query
  })
}

// 查询计件工资单价-CC详细
export async function getBomSalaryUnitPriceCc (id) {
  return request({
    url: '/bom/bomSalaryUnitPriceCc/' + id,
    method: 'get'
  })
}

// 新增计件工资单价-CC维护
export async function addBomSalaryUnitPriceCc (data) {
  return request({
    url: '/bom/bomSalaryUnitPriceCc',
    method: 'post',
    data: data
  })
}

// 修改计件工资单价-CC维护
export async function updateBomSalaryUnitPriceCc (data) {
  return request({
    url: '/bom/bomSalaryUnitPriceCc',
    method: 'put',
    data: data
  })
}

// 删除计件工资单价-CC维护
export async function delBomSalaryUnitPriceCc (id) {
  return request({
    url: '/bom/bomSalaryUnitPriceCc/' + id,
    method: 'delete'
  })
}

// 导出计件工资单价-CC维护
export async function exportBomSalaryUnitPriceCc (params) {
  return request({
    url: '/bom/bomSalaryUnitPriceCc/export',
    method: 'post',
    data: params
  })
}
